import React, { useEffect, useMemo, useRef, useState } from "react";

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function TimePicker({
  value = "10:00",
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const [h, m] = useMemo(() => {
    const [hh = "10", mm = "00"] = String(value).split(":");
    return [pad(hh), pad(mm)];
  }, [value]);

  const hours = useMemo(() => Array.from({ length: 24 }, (_, i) => pad(i)), []);
  const minutes = useMemo(() => Array.from({ length: 60 }, (_, i) => pad(i)), []);

  // закрытие по клику вне
  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (!wrapRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  const setHour = (hh) => onChange?.(`${hh}:${m}`);
  const setMinute = (mm) => onChange?.(`${h}:${mm}`);

  return (
    <div ref={wrapRef} className="relative">
      {/* input */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="h-11 w-full rounded-[14px] border border-[#D6D9E0] bg-white px-4 text-left outline-none hover:border-[#2B7CFF] transition flex items-center justify-between"
      >
        <span className="font-medium text-[#111827]">{h}:{m}</span>
        <i className="fa-regular fa-clock text-[#6B7280]" />
      </button>

      {/* dropdown */}
      {open && (
        <div className="absolute z-20 mt-2 w-[220px] rounded-[18px] border border-[#E5E7EB] bg-white shadow-[0_18px_40px_rgba(0,0,0,0.18)] p-3">
          <div className="grid grid-cols-2 gap-3">
            {/* hours */}
            <div className="max-h-[220px] overflow-auto rounded-[12px] border border-[#EEF0F3]">
              {hours.map((hh) => (
                <button
                  key={hh}
                  type="button"
                  onClick={() => setHour(hh)}
                  className={`w-full px-3 py-2 text-[13px] text-left transition
                    ${hh === h
                      ? "bg-[#2B7CFF] text-white font-semibold"
                      : "hover:bg-[#F3F4F6] text-[#111827]"
                    }`}
                >
                  {hh}
                </button>
              ))}
            </div>

            {/* minutes */}
            <div className="max-h-[220px] overflow-auto rounded-[12px] border border-[#EEF0F3]">
              {minutes.map((mm) => (
                <button
                  key={mm}
                  type="button"
                  onClick={() => setMinute(mm)}
                  className={`w-full px-3 py-2 text-[13px] text-left transition
                    ${mm === m
                      ? "bg-[#2B7CFF] text-white font-semibold"
                      : "hover:bg-[#F3F4F6] text-[#111827]"
                    }`}
                >
                  {mm}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-3 flex justify-end">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="text-[12px] font-semibold text-[#2B7CFF] hover:underline"
            >
              Готово
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
